import { Download, FileSpreadsheet } from "lucide-react";
import { ContainerCard, EmployeeDetails, ModuleTitleCard } from "../../components/ui/cards";
import { Reactable } from "../../components/ui/reactable";
import { PAYROLL_PAY_SLIP } from "../../constants/api";
import { checkUserPermissionFunc, downloadPDF, getPrintData } from "../../components/common/CommonFunctions";
import { useState } from "react";
import { Button } from "../../components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "../../components/ui/tooltip";

const PaySlips = () => {

    const [payrollData, setPayrollData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);

    const { edit: editPermission } = checkUserPermissionFunc("payroll", "payslips", "SubMenu") || {};

    const columns = [
        {
            accessor: "employee_name",
            Header: "Employee",
            sortable: true,
            fixed: true,
            filterable: true,
            maxWidth: "350px",
            Cell: ({ value, row }) => {
                const record = row;

                let empDetails = {
                    ...record?.employee,
                    designation_id: record?.employee?.designation
                        ? {
                            id: record?.employee.designation.id,
                            designation_name: record?.employee.designation.name,
                        }
                        : { id: 0, designation_name: "" },
                    first_name: record?.employee?.employee_name || "-",
                    id: record?.employee?.employee_id || "-",
                };

                return <EmployeeDetails details={empDetails} size="xs" />;
            },
        },
        {
            accessor: "ctc",
            Header: "CTC",
            sortable: true,
            width: "130px",
            Cell: ({ value }) => (
                <span className="font-medium text-gray-900 dark:text-white">
                    ₹{value?.toLocaleString('en-IN', { minimumFractionDigits: 2 }) || '0.00'}
                </span>
            ),
        },
        {
            accessor: "earnings",
            Header: "Earnings",
            sortable: true,
            width: "130px",
            Cell: ({ value }) => (
                <span className="font-medium text-emerald-600 dark:text-emerald-400">
                    ₹{value?.toLocaleString('en-IN', { minimumFractionDigits: 2 }) || '0.00'}
                </span>
            ),
        },
        {
            accessor: "deductions",
            Header: "Deductions",
            sortable: true,
            width: "130px",
            Cell: ({ value }) => (
                <span className="font-medium text-rose-600 dark:text-rose-400">
                    ₹{value?.toLocaleString('en-IN', { minimumFractionDigits: 2 }) || '0.00'}
                </span>
            ),
        },
        {
            accessor: "lop_amount",
            Header: "LOP Amount",
            sortable: true,
            width: "130px",
            Cell: ({ value }) => (
                <span className="font-medium text-amber-600 dark:text-amber-400">
                    ₹{value?.toLocaleString('en-IN', { minimumFractionDigits: 2 }) || '0.00'}
                </span>
            ),
        },
        {
            accessor: "net_pay",
            Header: "Net Pay",
            sortable: true,
            width: "130px",
            Cell: ({ value }) => (
                <span className="font-bold text-emerald-600 dark:text-emerald-400">
                    ₹{value?.toLocaleString('en-IN', { minimumFractionDigits: 2 }) || '0.00'}
                </span>
            ),
        },
        {
            accessor: "reimbursements_total",
            Header: "Reimbursements",
            sortable: true,
            width: "130px",
            Cell: ({ value }) => (
                <span className="font-medium text-indigo-600 dark:text-indigo-400">
                    ₹{value?.toLocaleString('en-IN', { minimumFractionDigits: 2 }) || '0.00'}
                </span>
            ),
        },
        {
            accessor: "credits",
            Header: "Credits",
            sortable: true,
            width: "130px",
            Cell: ({ value }) => (
                <span className="font-medium text-emerald-600 dark:text-emerald-400">
                    ₹{value?.toLocaleString('en-IN', { minimumFractionDigits: 2 }) || '0.00'}
                </span>
            ),
        },
        {
            accessor: "debit",
            Header: "Debit",
            sortable: true,
            width: "130px",
            Cell: ({ value }) => (
                <span className="font-medium text-rose-600 dark:text-rose-400">
                    ₹{value?.toLocaleString('en-IN', { minimumFractionDigits: 2 }) || '0.00'}
                </span>
            ),
        },
        ...(editPermission ? [
            {
                accessor: "actions",
                Header: "Actions",
                width: "90px",
                fixed: true,
                align: 'right',
                Cell: ({ row }) => {

                    const handleDownload = () => {
                        const payslipUrl = row.payslip;
                        downloadPDF(payslipUrl);
                    }

                    return (
                        <div className="flex items-center gap-2">
                            <Button variant="outline" size="sm" onClick={() => handleDownload(row)}>
                                <Download className="h-4 w-4" />
                            </Button>
                        </div>
                    )
                }
            }
        ] : [])
    ]

    return (
        <ContainerCard>
            {/* Header */}
            <ModuleTitleCard Icon={FileSpreadsheet} title={'Processed Payslips'} subtitle="Manage and process employers Payslips" totalRecords={totalRecords} />

            <Reactable
                columns={columns}
                pagename={"payslips"}
                data={payrollData}
                setData={setPayrollData}
                setTotalRecords={setTotalRecords}
                url={PAYROLL_PAY_SLIP}
                serverSide={true}
                tableHeight="calc(100vh - 320px)"
                rowSize={editPermission ? "sm" : undefined}
                isMonthYearRequired
                isFromToDateRequired={false}
            />

        </ContainerCard>
    );
}

export default PaySlips;